const REG_AWS_CDN_IMAGE_URL = /^(?:https?:)?(\/\/img.flamingo.shop)(\/.*.(jpe?g|webp|png|svg|gif)?(\?.*)?$)/i
const AWS_CDN_HOST = '//img.flamingo.shop'

const parseAwsCdnImageUrl = src => {
  const matched = REG_AWS_CDN_IMAGE_URL.exec(src)

  if (!matched) {
    return {
      matched: false
    }
  }

  const [
    originalSrc,
    srcDomain,
    srcPath
  ] = matched

  return {
    matched: true,
    originalSrc,
    srcDomain,
    srcPath
  }
}

// https://img.flamingo.shop/fit-in/180x180/show/20210906/images/02cd7fee0eb111ec9e300242ac110002.jpeg
// https://img.flamingo.shop/show/20210906/images/02cd7fee0eb111ec9e300242ac110002.jpeg

const getImageResize = maxWidth => {
  if (maxWidth) {
    if (maxWidth <= 90) {
      return '/fit-in/90x90'
    } else if (maxWidth <= 180) {
      return '/fit-in/180x180'
    } else if (maxWidth <= 480) {
      return '/fit-in/480x480'
    } else if (maxWidth >= 1080) {
      return ''
    } else {
      return '/fit-in/720x720'
    }
  }

  return ''
}

const genAwsCdnImageUrl = ({
  srcDomain,
  srcPath,
  maxWidth = 720,
  crop,
  quality = 0
}) => {
  const imageResize = getImageResize(maxWidth)
  // not yet support webp at this time

  let url = `https:${srcDomain}`

  if (crop) {
    url += `/${crop.width}x${crop.height}`
  } else {
    url += `${imageResize}`
  }

  if (quality > 0) {
    url += `/filters:quality(${quality})`
  }

  return `${url}/filters:strip_exif()${srcPath}`
}


const isAwsCdnImageUrl = src => src.indexOf(AWS_CDN_HOST) > -1

const adjustAwsCdnImageUrl = (url, { maxWidth, crop, quality } = {}) => {
  const params = parseAwsCdnImageUrl(url)
  if (!params.matched || params.srcPath.indexOf('filters:strip_exif()') > -1) {
    return url
  }

  return genAwsCdnImageUrl({
    srcDomain: params.srcDomain,
    srcPath: params.srcPath,
    maxWidth,
    crop,
    quality
  })
}

export {
  isAwsCdnImageUrl,
  adjustAwsCdnImageUrl
}
